import { gql } from '@apollo/client';

import { ASSET2_FRAGMENT } from '../fragments/asset2Fragment';

export const GET_ASSET_2_BY_ID = gql`
  query getAsset2ByID($assetID: String!) {
    getAsset2ByID(assetId: $assetID) {
      ...asset2Fragment
    }
  }
  ${ASSET2_FRAGMENT}
`;
